/**
 *
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/4/29      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import {Form,TreeSelect} from "antd";
import PropTypes from "prop-types";
import "./index.less";
const { TreeNode } = TreeSelect;

class Category extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            categoryList:[],
            checkedKeys:[]
        }
    }

    onChange = (value, label, extra) => {
        this.setState({
            checkedKeys:value
        })
    };

    /**
     * 获取二级类目
     */
    loadData=(treeNode)=>{
        return new Promise(resolve => {
            let id = treeNode.props.eventKey;
            $.ajax({
                method: 'post',
                url: '/service/mg/goods/category/list',
                contentType: 'application/json',
                data: JSON.stringify({
                    isEnable: 1,
                    parentId: id
                }),
                success: (resp)=> {
                    if(resp.valid&&resp.success){
                        let categoryList = resp.models||[];
                        treeNode.props.dataRef.categoryList = categoryList;
                        this.setState({
                            categoryList:[...this.state.categoryList]
                        });
                    }
                    resolve();
                }
            })
        })
    }

    componentDidMount(){
        $.ajax({
            method: 'post',
            url: '/service/mg/goods/category/list',
            contentType: 'application/json',
            data: JSON.stringify({
                isEnable: 1,
                parentId: 0
            }),
            success: (resp)=> {
                if(resp.valid&&resp.success){
                    this.setState({
                        categoryList:[].concat(resp.models||[])
                    })
                }
            }
        });
    }

    /**
     *获取2级
     * **/
    getNode(item,level,parentLevel){
        let _this = this;
        let state = _this.state;
        return <TreeNode checkable={false} isLeaf={(parentLevel==3||(level==2&&level==parentLevel))?true:false}
                         title={item.name}
                         loadData={this.loadData}
                         value={item.id}
                         key={item.id}
                         dataRef={item}>
            {item.categoryList&&item.categoryList.map(function (secondItem) {
                return _this.getNode(secondItem,item.level,secondItem.level)
            })}
        </TreeNode>
    }


    render(){
        let _this = this;
        let state = this.state;
        return <div className="category">
            <Form.Item {...this.props.col} name="categoryId" colon={false} label={__getServerLanguage("ShangPinLeiMu")}>
                <TreeSelect
                    loadData={this.loadData}
                    onChange={this.onChange}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder={__getServerLanguage("QingXuanZeShangPinSuoShuL")}
                    allowClear
                >
                    {state.categoryList.map(function (item,index) {
                        return  _this.getNode(item);
                    })}
                </TreeSelect>
            </Form.Item>
        </div>
    }
}
Category.defaultProps = {
};

Category.propTypes = {
};

export default Category;
